import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Section from 'components/common/Section';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import InsulinStatisticsChart from '../../../charts/InsulinStatisticsChart';
import DialogButton from 'components/common/DialogButton';
import ExerciseDialog from 'components/dialogs/ExerciseDialog';

import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import React from 'react';
import useReportInsulinStats from 'hooks/communication/useReportInsulinStats';
import usePaging from 'hooks/tables/usePaging';
import * as Luxon from 'luxon'
import { luxonClone } from 'utils/time';
import PagingIndicator from 'components/common/paging/PagingIndicator';
import defaultRenderPrevButtons from 'components/common/paging/defaultRenderPrevButtons';
import defaultRenderNextButtons from 'components/common/paging/defaultRenderNextButtons';
import WEEK_DAY_COLUMNS from 'constants/WEEK_DAY_COLUMNS';
import useSetChartData from 'hooks/app/useSetChartData';

const PAGE_ROW_CNT = 5;

export default function InsulinStatistics(props) {
  const {
    category,
    duration,
    ...rest
  } = props;

  const {
    page,
    onPage,
    npage,
    onNPage,
    maxPage,
    onMaxPage
  } = usePaging({
    resetCondition: [],
    defaultMaxPage: 6,
  });

  const {
    requestReportInsulinStats,
  } = useReportInsulinStats();

  const setChartData = useSetChartData('InsulinStatList');
  const [list, setList] = React.useState([]);
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    requestReportInsulinStats({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
      page_row_cnt: PAGE_ROW_CNT,
      page_no: npage,
    }, (success, data) => {
      if (success) {
        setChartData(() => ({ list: data.insulin_stat_list }));
        setList(() => data.insulin_stat_list);
        onMaxPage(data.max_page_no || 1);
        onPage(data.page_no || 1);
      } else {
        setChartData(() => ({ list: [] }));
        setList(() => []);
        onMaxPage(1);
        onPage(1);
        onNPage(1);
      }
    });
  }, [npage, onMaxPage, onNPage, onPage, patient_no, period_end, period_start, requestReportInsulinStats]);

  return (
    <Section
      {...ex('InsulinStatistics', rest)}
      {...{
        caption: T('일별 통계'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      <InsulinStatisticsChart {...{ duration }} />
      <table>
        <thead>
          <tr>
            <th>
              <div>
                {T('날짜')}
              </div>
            </th>
            <th>
              <div>
                {T('전체 투여량(U)')}
              </div>
            </th>
            <th>
              <div>
                {T('기저 투여량(U)')}
              </div>
            </th>
            <th>
              <div>
                {T('볼루스 투여량(U)')}
              </div>
            </th>
            <th>
              <div>
                {T('볼루스 투여기록(회)')}
              </div>
            </th>
            <th>
              <div>
                {T('볼루스 1회 평균 투여량(U)')}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {list.map((item, index) => {
            const {
              time,
              insulin_amt,
              giju_amt,
              bolus_amt,
              bolus_cnt,
              once_avg_bolus_amt,
            } = item;
            const luxon = Luxon.DateTime.fromFormat(time, 'yyyyMMdd');
            const date = luxon.toFormat("yy.MM.dd");
            const weekday = luxonClone(luxon).weekday;
            return (
              <tr key={index}>
                <td>
                  <div>
                    <DialogButton
                      {...{ category: 'App' }}
                      {...ex('ExerciseDialogButton')}
                      {...{ label: T('{0}({1})', date, WEEK_DAY_COLUMNS[weekday - 1]) }}
                    >
                      <ExerciseDialog
                        {...{
                          luxon,
                        }}
                      />
                    </DialogButton>
                  </div>
                </td>
                <td>
                  <div>
                    {insulin_amt}
                  </div>
                </td>
                <td>
                  <div>
                    {giju_amt}
                  </div>
                </td>
                <td>
                  <div>
                    {bolus_amt}
                  </div>
                </td>
                <td>
                  <div>
                    {bolus_cnt}
                  </div>
                </td>
                <td>
                  <div>
                    {once_avg_bolus_amt}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <PagingIndicator
        {...{
          indicatorCount: 5,
          maxPage,
          page,
          onNPage,
          renderPrevButtons: defaultRenderPrevButtons,
          renderNextButtons: defaultRenderNextButtons,
        }}
      />
    </Section>
  );
}
